// extracted by mini-css-extract-plugin
module.exports = {"value":"entity_block_line-module__value--3lYgz","hover":"entity_block_line-module__hover--RskVo"};